import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import Vue from 'vue';
import VueLodash from 'vue-lodash';

Vue.use(VueLodash, { lodash: { isEqual, isEmpty, get, has, capitalize } });
